import ru from '@/common/i18n/ru'
import sl from '@/common/i18n/sl'

export default {
  ru,
  sl
}
